import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@/store';
import { homeRouteFor } from '@/utils/constants';

const GuestRoute = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const user = useAppSelector((state) => state.auth.user);

  if (isAuthenticated) {
    return <Navigate to={homeRouteFor(user)} replace />;
  }

  return <Outlet />;
};

export default GuestRoute;
